export default "__VITE_ASSET__vasPhPZs__"